import Vue from 'vue'
import Router from 'vue-router'


import InicioComponent from '../components/InicioComponent'
import Ventas from '../components/Ventas.vue'
import ReporteVentas from '../components/ReporteVentas.vue'
import Inventario from '../components/InventarioComponent.vue' 
import Auditoria from '../components/Reportes/Auditoria.vue'

import Membresias from '../components/Membresias/Membresias'
import Miembros from '../components/Miembros/Miembros'
import NuevoMiembro from '../components/Miembros/NuevoMiembro'
import EditarMiembro from '../components/Miembros/EditarMiembro'

import Usuarios from '../components/Usuarios/Usuarios'
import NuevoUsuario from '../components/Usuarios/NuevoUsuario'
import EditarUsuario from '../components/Usuarios/EditarUsuario'
import CambiarPassword from '../components/Usuarios/CambiarPassword'
import MiPerfil from '../components/Usuarios/MiPerfil'

import Pagos from '../components/Pagos/Pagos'
import RegistrarVisita from '../components/Visitas/RegistrarVisita'
import Visitas from '../components/Visitas/Visitas'

import ConfiguracionComponent from '../components/Configuracion/ConfiguracionComponent'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'InicioComponent',
      component: InicioComponent
    },
    {
      path: '/ventas',
      name: 'Ventas',
      component: Ventas
    },
    {
      path: '/reporte-ventas',
      name: 'ReporteVentas',
      component: ReporteVentas
    },
    {
      path: '/inventario',
      name: 'Inventario',
      component: Inventario
    },
    {
      path: '/pagos',
      name: 'Pagos',
      component: Pagos
    },
    {
      path: '/membresias',
      name: 'Membresias',
      component: Membresias
    },
    {
      path: '/miembros',
      name: 'Miembros',
      component: Miembros
    },
    {
      path: '/nuevo-miembro',
      name: 'NuevoMiembro',
      component: NuevoMiembro
    },
    {
      path: '/editar-miembro/:id',
      name: 'EditarMiembro',
      component: EditarMiembro,
    },
    {
      path: '/usuarios',
      name: 'Usuarios',
      component: Usuarios
    },
    {
      path: '/nuevo-usuario',
      name: 'NuevoUsuario',
      component: NuevoUsuario
    },
    {
      path: '/editar-usuario/:id',
      name: 'EditarUsuario',
      component: EditarUsuario,
    },
    {
      path: '/cambiar-password',
      name: 'CambiarPassword',
      component: CambiarPassword
    },
    {
      path: '/registrar-visita',
      name: 'RegistrarVisita',
      component: RegistrarVisita
    },
    {
      path: '/visitas',
      name: 'Visitas',
      component: Visitas
    },
    {
      path: '/configurar',
      name: 'Configurar',
      component: ConfiguracionComponent
    },
    {
      path: '/auditoria',
      name: 'Auditoria',
      component: Auditoria
    },
    {
      path: '/perfil',
      name: 'MiPerfil',
      component: MiPerfil
    },
  ]
})


// WEBPACK FOOTER //
// ./src/router/index.js